interface IField {
  control?: any;
  validateControl?: () => string | undefined;
  field: string;
  value: any;
  valid: boolean;
  error?: string;
}

class Form {
  /** valores almacenados */
  values: IField[] = [];

  /** Almacena un dato del formulario */
  setValue = (field: string, value: any, error?: string) : any => {
    const key = this.values.find(p => p.field === field);
    if (key) {
      key.value = value;
      key.error = error;
      key.valid = !error;
    } else {
      this.values.push({ field, value, valid: !error, error })
    }

    return this.getEntity();
  }

  /** Devuelve la entidad almacenada */
  getEntity = () : any => {
    const res : any = { };

    for(let i = 0; i < this.values.length; i++)
      res[this.values[i].field] = this.values[i].value;

    return res;
  }

  /** Guarda la info desde una entidad ya creada */
  setEntity = (entity: any) : any => {
    this.values = this.values ?? [];
    if (!entity) return;

    for(let key in entity) {
      const v = this.values.find(p => p.field === key);
      if (!v) {
        this.values.push({ 
          field: key,
          value: entity[key],
          valid: true
        });
      } else {
        v.value = entity[key];
        v.valid = true;
      }
    }

    return entity;
  }

  /** establece los valores en los controles conocidos */
  setEntityValues(entity: any) : any {
    if (!entity) return;

    for(let key in entity) {
      const value = this.values.find(p => p.field === key);
      if (value?.control && value.control.change)
        value.control.change(entity[key]);
    }

    return entity;
  }


  /** Devuelve el estado actual del form */
  getStatus = () : { valid: boolean, entity: any, errors?: string[] } => {
    return {
      valid: !this.values.find(p => !p.valid),
      entity: this.getEntity(),
      errors: this.values.filter(p => !p.valid).map(p => p.error ?? '')
    }
  }
  
  /** Agrega un control y lo asocia con un campo */
  add = (control: any, field: string, validate?: () => string | undefined) : void => {
    const v = this.values.find(p => p.field === field);
    if (v) {
      v.control = control;
      if (!!validate) v.validateControl = validate;
    } else {
      this.values.push({
        control,
        validateControl: validate,
        field,
        value: undefined,
        valid: true
      })
    }
  }

  /** devuelve la información almacenada para un campo */
  getFieldInfo = (field:string) : IField | undefined => this.values.find(p => p.field === field);

  /** verifica que todos los controles estén válidos */
  isFormValid = () => {
    let isvalid = true;
    for(let i = 0; i < this.values.length; i++) {
      const v = this.values[i];

      console.log("form.isFormValid", "control", v, "v.validateControl =", v.validateControl, v.validateControl && v.validateControl() !== undefined)
      if (v.validateControl) {
        if (v.validateControl() !== undefined) isvalid = false;
      } else {
        if (!v.valid) isvalid = false;
      }
      console.log("form.isFormValid", "isvalid =", isvalid)
    }

    return isvalid;
  }
}

export default Form;